import Linkify from "linkify-react";
import "./CustomLinkify.scss";

function CustomLinkify(props: any) {
  return (
      <div className={"mx-2 form-control " + props.className}>
        <Linkify
          as={props.as || "dev"}
          options={{
            target: "_blank",
            rel: "noopener noreferrer",
          }}
        >
          {props.text}
        </Linkify>
      </div>
  );
}

export default CustomLinkify;